/* ==========================================================================
   CALI: Product page behaviour
   D2 gallery dots · D6 size guide drawer · D9 sticky Add to cart
   Clean Initial URL + Perfect Default Variant Selection
   ========================================================================== */
(function () {
  'use strict';

  // 1. Initial Page Load par URL ko clean karna
  var _origReplaceState = window.history.replaceState;
  var _origPushState = window.history.pushState;

  if (window.location.search) {
    var cleanUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
    _origReplaceState.call(window.history, null, '', cleanUrl);
  }

  // 2. Real user click track karna (Auto-select ko URL update karne se rokna)
  var isAutoSelecting = false;
  var userInteracted = false;

  window.addEventListener('click', function (e) {
    if (!isAutoSelecting && e.isTrusted && e.target.closest('[data-product-swatch], .form-swatch-item, label, input, select')) {
      userInteracted = true;
    }
  }, true);

  window.addEventListener('change', function (e) {
    if (!isAutoSelecting && e.isTrusted && e.target.closest('[data-product-swatch], .form-swatch-item, input, select')) {
      userInteracted = true;
    }
  }, true);

  // 3. Initial load par URL update block, real user click par standard Shopify URL update
  window.history.replaceState = function (state, title, url) {
    if (!userInteracted || isAutoSelecting) {
      return;
    }
    return _origReplaceState.apply(this, arguments);
  };

  window.history.pushState = function (state, title, url) {
    if (!userInteracted || isAutoSelecting) {
      return;
    }
    return _origPushState.apply(this, arguments);
  };

  if (window.__caliPdpBound) return;
  window.__caliPdpBound = true;

  var mobile = window.matchMedia('(max-width: 720px)');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ------------------------------------------------------------------------
     D2 · Gallery dots
     ------------------------------------------------------------------------ */
  function initDots() {
    var $ = window.jQuery;
    var images = document.querySelector('.product-gallery-section [data-product-images]');
    if (!$ || !images) return;

    function build() {
      var slick = $(images).slick('getSlick');
      if (!slick || slick.slideCount < 2) return;
      var wrap = images.parentNode;
      var old = wrap.querySelector('.cali-gallery-dots');
      if (old) old.remove();

      var dots = document.createElement('div');
      dots.className = 'cali-gallery-dots';
      dots.setAttribute('role', 'group');
      dots.setAttribute('aria-label', 'Product images');

      for (var i = 0; i < slick.slideCount; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + slick.slideCount);
        b.setAttribute('aria-current', i === slick.currentSlide ? 'true' : 'false');
        b.dataset.index = i;
        dots.appendChild(b);
      }

      dots.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (btn) $(images).slick('slickGoTo', parseInt(btn.dataset.index, 10));
      });

      images.insertAdjacentElement('afterend', dots);

      $(images).off('afterChange.cali').on('afterChange.cali', function (event, s, current) {
        var all = dots.querySelectorAll('button');
        for (var j = 0; j < all.length; j++) all[j].setAttribute('aria-current', j === current ? 'true' : 'false');
      });
    }

    if (images.classList.contains('slick-initialized')) {
      build();
    } else {
      $(images).one('init', function () { setTimeout(build, 0); });
      var tries = 0;
      var poll = setInterval(function () {
        if (images.classList.contains('slick-initialized') || ++tries > 40) {
          clearInterval(poll);
          if (images.classList.contains('slick-initialized') && !images.parentNode.querySelector('.cali-gallery-dots')) build();
        }
      }, 150);
    }
  }

  /* ------------------------------------------------------------------------
     D6 · Size guide drawer
     ------------------------------------------------------------------------ */
  function initSizeGuide() {
    var sg = document.querySelector('[data-cali-size-guide]');
    if (!sg) return;
    document.body.appendChild(sg);

    var panel = sg.querySelector('.cali-sg__panel');
    var lastFocus = null;

    function open(trigger) {
      lastFocus = trigger || document.activeElement;
      sg.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        sg.classList.add('is-open');
        panel.focus({ preventScroll: true });
      });
    }

    function close() {
      if (sg.hidden) return;
      sg.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { sg.hidden = true; }, 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cali-size-guide-open]');
      if (opener) { e.preventDefault(); open(opener); return; }
      if (e.target.closest('[data-cali-size-guide-close]')) { e.preventDefault(); close(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    window.openSizeGuideModal = function () { open(); };
    window.closeSizeGuideModal = close;
  }

  /* ------------------------------------------------------------------------
     D9 · Mobile sticky Add to cart bar
     ------------------------------------------------------------------------ */
  function initSticky(root, product) {
    var bar = document.querySelector('[data-cali-sticky-atc]');
    var mainBtn = root.querySelector('[data-product-add]');
    if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;
    document.body.appendChild(bar);

    var priceEl = root.querySelector('[data-product-price]');
    var stickyPrice = bar.querySelector('[data-cali-sticky-price]');
    var stickyBtn = bar.querySelector('[data-cali-sticky-add]');
    var sizeGroup = root.querySelector('.cali-swatch-size');
    var sizeCount = sizeGroup ? sizeGroup.querySelectorAll('[data-product-swatch-value]').length : 0;
    var needsSize = sizeCount > 1;
    var sizeChosen = true;

    if (sizeGroup) {
      sizeGroup.addEventListener('change', function () { sizeChosen = true; });
    }

    function syncPrice() {
      if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent.trim();
    }
    if (priceEl && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
    syncPrice();

    var visible = false;
    function setVisible(show) {
      if (show === visible) return;
      visible = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyBtn.tabIndex = show ? 0 : -1;
      document.documentElement.classList.toggle('cali-sticky-on', show);
      moveChat(show);
    }

    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      // 14 Oct (Ali): on mobile the bar shows from the start; on desktop once the main button scrolls away
      setVisible(mobile.matches || (!e.isIntersecting && e.boundingClientRect.top < 0));
    }, { threshold: 0 });
    io.observe(mainBtn);

    // 14 Oct (Ali): price inside the main Add to cart button ("Add to cart \u00b7 AED 305").
    // theme.js rewrites the button on variant change, so re-add it whenever that happens.
    function decorateAtc() {
      if (mainBtn.disabled || !priceEl) return;
      var label = mainBtn.querySelector('.button-text');
      if (!label) return;
      var span = label.querySelector('.cali-atc-price');
      if (!span) { span = document.createElement('span'); span.className = 'cali-atc-price'; label.appendChild(span); }
      span.textContent = ' \u00b7 ' + priceEl.textContent.trim();
    }
    decorateAtc();
    if (window.MutationObserver) {
      new MutationObserver(decorateAtc).observe(mainBtn, { childList: true, attributes: true, attributeFilter: ['disabled'] });
      if (priceEl) new MutationObserver(decorateAtc).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    function nudgeSizes() {
      if (!sizeGroup) return;
      var top = sizeGroup.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top: top, behavior: 'smooth' });
      sizeGroup.classList.remove('cali-attention');
      void sizeGroup.offsetWidth;
      sizeGroup.classList.add('cali-attention');
      setTimeout(function () { sizeGroup.classList.remove('cali-attention'); }, 1600);
      var first = sizeGroup.querySelector('input:not(:disabled)');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
    }

    // 14 Oct (Ali): sticky bar follows the selected variant - image (if the variant has its own),
    // variant name and price on the button
    var stickyImg = bar.querySelector('.cali-sticky-atc__img');
    var stickyVar = bar.querySelector('[data-cali-sticky-variant]');
    var defaultImg = stickyImg ? stickyImg.getAttribute('src') : '';
    var idInput = root.querySelector('form[action*="/cart/add"] [name="id"]');
    var productData = null;
    try {
      var js = document.querySelector('[data-product-json], #ProductJson-product-template, script[type="application/json"][data-product]');
      if (js) productData = JSON.parse(js.textContent);
    } catch (e) {}
    function withProduct(cb) {
      if (productData && productData.variants) return cb(productData);
      var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return;
      fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) { productData = p; cb(p); }).catch(function () {});
    }
    // Sold-out option chips: diagonal line + grey (the chosen one keeps its border so it still reads as selected)
    function markSoldOut(p) {
      var items = root.querySelectorAll('.form-swatch-item');
      items.forEach(function (it) {
        var inp = it.querySelector('input[type="radio"]'); if (!inp) return;
        var m = (inp.name || '').match(/option-(\d+)$/); if (!m) return;
        var idx = +m[1];
        // currently chosen values of the other options
        var chosen = [];
        root.querySelectorAll('.form-swatch-item input[type="radio"]:checked').forEach(function (c) {
          var mm = (c.name || '').match(/option-(\d+)$/); if (mm) chosen[+mm[1]] = c.value;
        });
        var ok = p.variants.some(function (vv) {
          if (!vv.available || vv.options[idx] !== inp.value) return false;
          for (var k = 0; k < vv.options.length; k++) if (k !== idx && chosen[k] !== undefined && vv.options[k] !== chosen[k]) return false;
          return true;
        });
        it.classList.toggle('cali-soldout', !ok);
        if (!inp.checked) inp.disabled = !ok;   // can't pick a sold-out size (the one already chosen stays usable)
        var lab = it.querySelector('label'); if (lab) lab.setAttribute('aria-label', inp.value + (ok ? '' : ' - sold out'));
      });
    }
    function syncVariant() {
      var id = idInput ? String(idInput.value) : (new URLSearchParams(location.search)).get('variant');
      withProduct(function (p) {
        var v = null;
        // Prefer the sizes/options the shopper sees selected (the theme keeps the old id when a sold-out size is picked)
        var chosen = [];
        root.querySelectorAll('.form-swatch-item input[type="radio"]:checked').forEach(function (c) {
          var mm = (c.name || '').match(/option-(\d+)$/); if (mm) chosen[+mm[1]] = c.value;
        });
        if (chosen.length) {
          for (var j = 0; j < p.variants.length && !v; j++) {
            var match = true;
            for (var k = 0; k < chosen.length; k++) if (chosen[k] !== undefined && p.variants[j].options[k] !== chosen[k]) match = false;
            if (match) v = p.variants[j];
          }
        }
        for (var i = 0; i < p.variants.length && !v; i++) if (String(p.variants[i].id) === String(id)) v = p.variants[i];
        if (!v) v = p.variants[0];
        markSoldOut(p);
        if (stickyVar) stickyVar.textContent = p.variants.length > 1 ? ' \u00b7 ' + v.title : '';
        if (stickyImg) {
          var src = v.featured_image && v.featured_image.src ? v.featured_image.src : null;
          var url = src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160' : defaultImg;
          if (stickyImg.getAttribute('src') !== url) stickyImg.setAttribute('src', url);
        }
      });
      var price = priceEl ? priceEl.textContent.trim() : '';
      // Sold-out size: the sticky button becomes the pre-order (Instagram DM) link
      var label = mainBtn.disabled ? 'Pre-order via DM' : 'Add to cart' + (price ? ' \u00b7 ' + price : '');
      if (stickyBtn.textContent !== label) stickyBtn.textContent = label;
      stickyBtn.classList.toggle('is-preorder', !!mainBtn.disabled);
      // No "Buy it now" for a sold-out size
      root.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach(function (pb) { pb.style.display = mainBtn.disabled ? 'none' : ''; });
      stickyBtn.classList.remove('is-disabled');
      // Main button: say "Sold out" for the chosen size (theme text is "Preorder" but the button can't act)
      if (mainBtn.disabled) { var bt = mainBtn.querySelector('.button-text'); if (bt && bt.textContent !== 'Sold out') bt.textContent = 'Sold out'; }
    }
    syncVariant();
    if (idInput && window.MutationObserver) new MutationObserver(syncVariant).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    root.addEventListener('change', function () { setTimeout(syncVariant, 60); });
    if (priceEl && window.MutationObserver) new MutationObserver(syncVariant).observe(priceEl, { childList: true, characterData: true, subtree: true });
    if (window.MutationObserver) new MutationObserver(syncVariant).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });

    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled && stickyBtn.classList.contains('is-preorder')) {
        window.open('https://www.instagram.com/calishopofficial/', '_blank', 'noopener');
        return;
      }
      if ((needsSize && !sizeChosen) || mainBtn.disabled) {
        nudgeSizes();
        return;
      }
      mainBtn.click();
    });
  }

  function moveChat(up) {
    var hosts = document.querySelectorAll('#ShopifyChat, inbox-online-store-chat');
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var targets = [host];
      if (host.shadowRoot) targets = targets.concat([].slice.call(host.shadowRoot.querySelectorAll('*')));
      for (var j = 0; j < targets.length && j < 60; j++) {
        var el = targets[j];
        if (window.getComputedStyle(el).position !== 'fixed') continue;
        if (up) {
          if (el.dataset.caliBottom === undefined) el.dataset.caliBottom = el.style.bottom || '';
          el.style.setProperty('bottom', 'calc(88px + env(safe-area-inset-bottom, 0px))', 'important');
        } else if (el.dataset.caliBottom !== undefined) {
          el.style.bottom = el.dataset.caliBottom;
          delete el.dataset.caliBottom;
        }
        break;
      }
    }
  }

  /* ------------------------------------------------------------------------
     Auto Select First Variant
     ------------------------------------------------------------------------ */
  function autoSelectFirstOption() {
    if (userInteracted) return;

    // CALI 14 Oct (Ali): open on the first size that is in stock; sold-out sizes are crossed and disabled
    var firstSwatch = null;
    try {
      var pr = document.querySelector('.cali-pdp[data-section-product-main]');
      var pj = pr ? JSON.parse(pr.getAttribute('data-product-json')) : null;
      var fa = pj && pj.variants ? pj.variants.filter(function (v) { return v.available; })[0] : null;
      if (fa && !/[?&]variant=/.test(location.search)) {
        document.querySelectorAll('.form-swatch-item input[type="radio"]').forEach(function (inp) {
          if (!firstSwatch && /option-0$/.test(inp.name) && inp.value === fa.options[0]) firstSwatch = inp.closest('.form-swatch-item');
        });
      }
    } catch (e) {}
    if (!firstSwatch && /[?&]variant=/.test(location.search)) { var ck = document.querySelector('.form-swatch-item input:checked'); if (ck) firstSwatch = ck.closest('.form-swatch-item'); }
    if (!firstSwatch) firstSwatch = document.querySelector('.form-swatch-item');
    if (!firstSwatch) return;

    var radio = firstSwatch.querySelector('input[type="radio"]');
    var label = firstSwatch.querySelector('label');

    isAutoSelecting = true;
    // CALI 14 Oct: clicking the size label focuses the radio and the browser scrolled the page down to the sizes on load
    var keepX = window.scrollX, keepY = window.scrollY;

    if (radio) {
      radio.checked = true;
    }

    if (label) {
      label.click();
      if (label.blur) label.blur();
    }

    if (radio) {
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      if (radio.blur) radio.blur();
    }

    window.scrollTo(keepX, keepY);
    setTimeout(function () { if (Math.abs(window.scrollY - keepY) > 40 && !userInteracted) window.scrollTo(keepX, keepY); }, 0);

    setTimeout(function () {
      isAutoSelecting = false;
    }, 60);
  }

  ready(function () {
    var root = document.querySelector('.cali-pdp[data-section-product-main]');
    var product = null;
    if (root) {
      try { product = JSON.parse(root.getAttribute('data-product-json')); } catch (e) {}
    }

    // 4. Clean CSS: Dono variants ko 100% identical rakhna aur focus lines hatana
    if (!document.getElementById('cali-swatch-identical-style')) {
      var style = document.createElement('style');
      style.id = 'cali-swatch-identical-style';
      style.textContent = ''
        + '.form-swatch-item { border: none !important; padding: 0 !important; box-shadow: none !important; outline: none !important; } '
        + '.form-swatch-item label { outline: none !important; box-shadow: none !important; -webkit-tap-highlight-color: transparent !important; } '
        + '.form-swatch-item input[type="radio"]:checked + label { '
        + '  background-color: #000 !important; '
        + '  color: #fff !important; '
        + '  border: 1px solid #000 !important; '
        + '  outline: none !important; '
        + '  box-shadow: none !important; '
        + '} '
        + '.form-swatch-item *:focus, .form-swatch-item *:focus-visible { '
        + '  outline: none !important; '
        + '  box-shadow: none !important; '
        + '}';
      document.head.appendChild(style);
    }

    // 5. Disable states clear karna
    var allSwatches = document.querySelectorAll('.form-swatch-item input');
    allSwatches.forEach(function (inp) {
      inp.disabled = false;
      var parent = inp.closest('.form-swatch-item');
      if (parent) {
        parent.classList.remove('cali-soldout');
      }
    });

    // 6. Page load par pehla variant trigger karna
    autoSelectFirstOption();
    setTimeout(autoSelectFirstOption, 120);
    setTimeout(autoSelectFirstOption, 350);

    initDots();
    initSizeGuide();
    if (root && product) {
      initSticky(root, product);
    }
  });
})();